/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, pxToEm, convertHexToRGB } from '@insticator/insticator-ui';



/* ++++++++++ --------------- EXPORT : FORM : FIELD : ERROR MESSAGE : STYLES --------------- ++++++++++ */
export default {
	errormessage: {
		opacity: '0',
		display: 'block',
		color: convertHexToRGB(theme.color.attention.dark.swatch, 50),
		fontSize: pxToEm(14),
		marginTop: pxToEm(5),
		// animate in
		animationName: 'fadeInDown',
		animationDelay: '0s',
		animationDuration: '.1s',
		animationFillMode: 'forwards',
	}
};
